import {Stack, styled, Typography} from '@mui/material';

const StyledANSContainer = styled(Stack)`
	align-items: center;
	flex-direction: row;
	justify-content: center;
	gap: 16px;
	flex-wrap: wrap;
	max-width: 355px;
	color: ${({theme}) => theme.palette.text.primary};

	& div svg {
		min-width: fit-content !important;
	}
`;

const StyledTypography = styled(Typography)`
	font-weight: 600;
	font-size: 10px;
	color: ${({theme}) => theme.palette.text.primary};
`;

export {StyledTypography, StyledANSContainer};
